(function ($, window, document) {
/**
 * Click handler for toggle buttons
 *
 * @param {object} ev - Event object
 */
function onToggleClick(ev) {
  ev.preventDefault();
}

/**
 * Toggle Login button toggle (collapse) functionality
 *
 * @param {object} mq - Media query object
 * @param {boolean} isLogged - User login status
 */
function toggleLoginButtonToggle(mq, isLogged) {
  if (isLogged && mq.matches) {
    addLoginButtonToggle();
  } else {
    removeLoginButtonToggle();
  }
}

/**
 * Add login button toggle (collapse) functionality
 */
function addLoginButtonToggle() {
  var $userLoginBtn = $('.js-login-btn');
  $userLoginBtn.attr('data-toggle', 'collapse');
  $userLoginBtn.bind('click', onToggleClick);
}

/**
 * Remove login button toggle (collapse) functionality
 */
function removeLoginButtonToggle() {
  var $userLoginBtn = $('.js-login-btn');
  $userLoginBtn.removeAttr('data-toggle');
  $userLoginBtn.unbind('click', onToggleClick);
}

/**
 * Show (possibly hidden) logout button
 */
function showLogoutButton() {
  var $userLogoutBtn = $('.js-logout-btn');
  $userLogoutBtn.removeClass('hidden');
}

/**
 * Hide (possibly visible) logout button
 */
function hideLogoutButton() {
  var $userLogoutBtn = $('.js-logout-btn');
  $userLogoutBtn.addClass('hidden');
}

/**
 * Enable My Insurance navigation behavior
 */
function enableMyInsuranceNavigation() {
  var $myInsuranceToggle = $('.js-dropdown-my-insurance-toggle'),
      $myInsuranceNavigation = $('.js-dropdown-my-insurance');

  $myInsuranceToggle.attr('data-toggle', 'collapse');
  $myInsuranceToggle.bind('click', onToggleClick);
  $myInsuranceToggle.find('span').removeClass('hidden');

  $myInsuranceNavigation.removeClass('hidden');
}

/**
 * Disable My Insurance navigation behavior
 */
function disableMyInsuranceNavigation() {
  var $myInsuranceToggle = $('.js-dropdown-my-insurance-toggle'),
      $myInsuranceNavigation = $('.js-dropdown-my-insurance');

  $myInsuranceToggle.removeAttr('data-toggle');
  $myInsuranceToggle.unbind('click', onToggleClick);
  // $myInsuranceToggle.find('span').addClass('hidden');

  $myInsuranceNavigation.addClass('hidden');
}

function showEnvironment(environment) {
  var style = {
    background: 'white',
    'border-left': '1px solid #444',
    'border-bottom': '1px solid #444',
    'border-bottom-left-radius': '4px',
    color: '#444',
    'font-size': '13px',
    padding: '5px 15px',
    position: 'fixed',
    right: 0,
    'z-index': 12
  }
  var $environment = $('<div id="environment"><p style="margin:0">'+ environment + '</p></div>');
  //$('body').prepend($environment);
  //$('#environment').css(style);
}

function userDropdown(userName) {
  var userMenu = ('<div class="navbar-user-dropdown-menu"> ' +
    '<button id="logged-in-user-menu" class="text-box reset-root" tabindex="0" role="button" aria-haspopup="true" aria-expanded="true" aria-label="Käyttäjän valikko" onclick="this.parentElement.classList.toggle(\'active\')"> ' +
      '<span class="dropdown-icon reset-root"></span><span class="text-label logged-in-user-desktop reset-root" hidden>'+userName+'</span>' +
    '</button>' +
      '<div class="options">' +
        '<div class="logged-in-user-mobile"><span class="text-label">'+userName+'</span>' +
        '</div> ' +
        '<div class="option">' +
          '<button id="my-insurance-user-item" class="reset-root" onclick="location.href=\'/omapalvelu\'">' +
            '<span class="user-icon reset-root"></span><span class="text-label reset-root">Oma Palvelu</span>' +
          '</button> ' +
        '</div>' +
        '<div class="option">' +
          '<button id="logout-user-item" class="reset-root" onclick="location.href=\'/kirjaudu-ulos?redirectPath='+window.location.pathname+'\'">' +
            '<span class="logout-icon reset-root"></span><span class="text-label reset-root">Kirjaudu ulos</span>' +
          '</button> ' +
        '</div>' +
      '</div> ' +
    '</div>')

  return userMenu
}

  /**
   * Set user name & status to navbar elements
   *
   * @param {object} user - User object
   *                 user.logged - Authentication status
   *                 user.userName - User name
   */

function setUser(user) {
  //
  // Initialization
  // --------------
  function onDOMContentLoaded() {
    var $loginStatusText = $('.js-login-status-text'),
      $userDropdown = $('.user-logged-in-area'),
      $mobileMyinsurance = $('.navbar-mobile-myinsurance-link'),
      $mobileNavMyinsuranceItem = $('.mobile-navigation-item-omapalvelu'),
      $body = $(document.body),
      isLogged = user.logged,
      mq;

    if (isLogged) {
      $body.addClass('is-logged-in');
      if (window.location.href.indexOf("marionette") === -1 &&
          window.location.href.indexOf("/omapalvelu/vahingot-ja-korvaukset/") === -1 ) {
        $userDropdown.html(userDropdown(user.userName))
      } else {
        $userDropdown.html('')
      }
      enableMyInsuranceNavigation();
      $loginStatusText.find('.icon-login').hide().next('.icon-logged-in').removeClass('hidden')
    } else {
      $loginStatusText.html('Kirjaudu sisään <span class="secondary-nav-toggle-icon icon-login"></span>');
      $mobileMyinsurance.html('<span class="secondary-nav-toggle-icon icon-login"></span>')
      $mobileNavMyinsuranceItem.html('Kirjaudu sisään')
      $body.removeClass('is-logged-in');
      hideLogoutButton();
      disableMyInsuranceNavigation();
    }

    // Toggle Login button functionality based on viewport width and login
    // status. Fake the matchMedia object for browsers not supporting it.
    if (window.matchMedia) {
      mq = window.matchMedia('(max-width: 991px)');
      mq.addListener(function () {
        toggleLoginButtonToggle(mq, isLogged);
      });
    } else {
      mq = {matches: false};
    }

    if (typeof user.environment !== 'undefined') {
      showEnvironment(user.environment);
    }

    toggleLoginButtonToggle(mq, isLogged);
  }
  if (document.readyState == 'loading') {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
  } else {
    onDOMContentLoaded();
  }
}
window.setUser = setUser;

})(jQuery, window, document);
